import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

// showTaskOption -- whether to offer "Select from Tasks List". Only Maintenance
// logbooks support completing a Task into an entry, so other types omit it and
// go straight to a blank entry. Defaults to true for backward compatibility.
//
// `restoreFocus={false}` because this chooser is a HAND-OFF, not a destination:
// both of its actions close it and open another modal on top. @restart/ui's
// Modal captures whatever was focused when it opened (here the logbook card's
// Add button) and calls .focus() on it from handleHide -- which runs when the
// FADE-OUT finishes, ~300ms after the replacement modal has already mounted and
// been typed into. So the outgoing chooser reaches across and blurs a field in
// the modal that replaced it; the entry form's Trip Name box would lose its
// suggestion menu (TripSuggestInput closes on blur) with nothing to reopen it.
// The cost is that Cancel now leaves focus where the modal left it rather than
// back on Add -- the two hand-off paths are the common ones and they are the
// ones this breaks.
export const PickLogbookAddType = ({ show, onHide, onSelectTask, onAddAdHoc, showTaskOption = true }) => (
    <Modal show={show} restoreFocus={false}>
        <h3><div className='text-center'>Add to Logbook</div></h3>
        { showTaskOption && (
            <div className='text-center p-1'>
                <Button className='btn btn-primary col-6' onClick={onSelectTask}>
                    Select from Tasks List
                </Button>
            </div>
        )}
        <div className='text-center p-1'>
            <Button className='btn btn-primary col-6' onClick={onAddAdHoc}>
                Add/Edit a new Entry
            </Button>
        </div>
        <div className='text-center p-3'>
            <Button className='btn btn-danger col-6' onClick={onHide}>
                Cancel
            </Button>
        </div>
    </Modal>
)
